function percentage(partialValue = 0, totalValue = 0) {
    return Math.floor(
        (100 * Number(partialValue)) / Number(totalValue),
    );
}

export default percentage;
